export default "__VITE_ASSET__C7eLXyed__"